import { get, post } from './'
import _ from 'lodash'
import {
  ColorMarkers,
  ClarityMarkers,
  FluorescenceIntensityMarkers,
  FancyIntensityMarkers,
  CutMarkers,
  PolishMarkers,
  SymmetryMarkers
} from '../utils/slider-markers'
import {
  DepthPercentageSlider,
  TablePercentageSlider,
  LWRatioSlider,
  SizeSlider,
  WeightSlider
} from '../utils/slider-configs'

export function getAllSuppliers () {
  return get('/suppliers')
}

export function getDiamondMarkups () {
  return get('/markup')
}

export function getCurrency () {
  return get('/currency?code=CAD')
}

const getMarkupFullName = (markupType) => {
  if (markupType === 'CP') {
    return 'Cost Price'
  } else if (markupType === 'BP') {
    return 'Base Price'
  } else if (markupType === 'SP') {
    return 'Sale Price'
  }
}

const enumSliderIsNotFullRange = (rangeField, markers) => {
  return !(rangeField[0] === 0 && rangeField[1] === _.size(markers))
}

const assignEnumSliderRangeValue = (filterField, markers, searchFilter, lowerBoundField, upperBoundField) => {
  if (enumSliderIsNotFullRange(filterField, _.keys(markers))) {
    searchFilter[lowerBoundField] = markers[_.keys(markers)[filterField[0]]]
    searchFilter[upperBoundField] = markers[_.keys(markers)[filterField[1] - 1]]
  }
}

const numericSliderIsNotFullRange = (rangeField, sliderConfig) => {
  return !(rangeField[0] === sliderConfig.min && rangeField[1] === sliderConfig.max)
}

const assignNumericSliderRangeValue = (filterField, sliderConfig, searchFilter, fieldName) => {
  if (numericSliderIsNotFullRange(filterField, sliderConfig)) {
    searchFilter[fieldName] = filterField
  }
}

export function diamondSearch (filters, currentPage, settings, hitsPerPage) {
  var diamondSearchFilters = {
    price_unit: filters.priceUnit,
    markup_type: getMarkupFullName(settings.markupType),
    currency: settings.currency.toUpperCase(),
    price_low: filters.price[0],
    price_high: filters.price[1],
    shapes: filters.shapes,
    fancy_colors: filters.colourFancy,
    grading: filters.gradingreports,
    labreports: filters.labreports,
    primary_suppliers: filters.primarySuppliers,
    preferred_suppliers: filters.preferredSuppliers,
    other_suppliers: filters.otherSuppliers,
    suppliers: filters.suppliers,
    supplier_types: filters.supplierTypes,
    serialnumbers: filters.serialnumbers.split(/[ ,]+/).filter(Boolean),
    canada_origin: filters.canadaorigin,
    locations: filters.locations,
    with_image: filters.withImage,
    size_unit: filters.sizeUnit,
    colour_type: filters.colourType,
    matched_sets: filters.matchedsets,
    order_by: filters.orderBy,
    sort_by_field: filters.sortByField,
    current_page: currentPage,
    limit: hitsPerPage,
    diamond_type: filters.diamondType
  }

  // if fluorescence is not full range then add fluorescence_start and fluorescence_end
  assignEnumSliderRangeValue(filters.fluorescence, FluorescenceIntensityMarkers, diamondSearchFilters, 'fluorescence_start', 'fluorescence_end')
  // if cut is not full range then add cut_start and cut_end
  assignEnumSliderRangeValue(filters.cut, CutMarkers, diamondSearchFilters, 'cut_start', 'cut_end')
  // if polish is not full range then add polish_start and polish_end
  assignEnumSliderRangeValue(filters.polish, PolishMarkers, diamondSearchFilters, 'polish_start', 'polish_end')
  // if color is not full range then add color_start and color_end
  assignEnumSliderRangeValue(filters.colour, ColorMarkers, diamondSearchFilters, 'color_start', 'color_end')
  // if clarity is not full range then add clarity_start and clarity_end
  assignEnumSliderRangeValue(filters.clarity, ClarityMarkers, diamondSearchFilters, 'clarity_start', 'clarity_end')
  // if symmetry is not full range then add symmetry_start and symmetry_end
  assignEnumSliderRangeValue(filters.symmetry, SymmetryMarkers, diamondSearchFilters, 'symmetry_start', 'symmetry_end')
  // if fancy intensity is not full range then add fancyintensity_start and fancyintensity_end
  assignEnumSliderRangeValue(filters.fancyIntensity, FancyIntensityMarkers, diamondSearchFilters, 'fancyintensity_start', 'fancyintensity_end')

  // if size is not full range then add it to the filter
  assignNumericSliderRangeValue(filters.size, SizeSlider, diamondSearchFilters, 'size')
  // if weight is not full range then add it to the filter
  assignNumericSliderRangeValue(filters.weight, WeightSlider, diamondSearchFilters, 'weight')
  // if depth% is not full range then add it to the filter
  assignNumericSliderRangeValue(filters.depth, DepthPercentageSlider, diamondSearchFilters, 'depth')
  // if table% is not full range then add it to the filter
  assignNumericSliderRangeValue(filters.table, TablePercentageSlider, diamondSearchFilters, 'table')
  // if l/w ratio is not full range then add it to the filter
  assignNumericSliderRangeValue(filters.ratio, LWRatioSlider, diamondSearchFilters, 'ratio')

  return post('/diamond', diamondSearchFilters)
}



// WEBPACK FOOTER //
// ./src/api/diamond.js